import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import NavBar from '../NavBar';
import {
	requestBibliotecaDocumentos,
	bibliotecaRepositoriosCategorias,
	bibliotecaRepositoriosTemas,
} from '../../services/requests';
import IconeDocumento from '../../images/document.png';

export default function MaternidadesHospitais() {
	// Estados dos filtros
	const [titulo, setTitulo] = useState('');
	const [ano, setAno] = useState('');
	const [categoria, setCategoria] = useState('');
	const [tema, setTema] = useState('');
	// Estado dos documentos
	const [documentos, setDocumentos] = useState([]);
	const [loading, setLoading] = useState(true);

	// Estados de paginação
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [totalPages, setTotalPages] = useState(0);

	// Estados para opções dos filtros
	// Removido: const [temasOpcoes, setTemasOpcoes] = useState([]);
	const [categoriasOpcoes, setCategoriasOpcoes] = useState([]);
	const [temasOpcoes, setTemasOpcoes] = useState([]);

	// Função para obter o token do usuário
	const getUserToken = () => {
		const userCookie = Cookies.get('user');
		if (userCookie) {
			try {
				const userData = JSON.parse(userCookie);
				return userData.token;
			} catch (error) {
				console.error('Erro ao parsear dados do usuário:', error);
				return null;
			}
		}
		return null;
	};

	useEffect(() => {
		async function loadDocs() {
			try {
				setLoading(true);

				const id = 3;
				const algumFiltro =
					titulo || ano || categoria?.length || tema?.length;

				const params = {
					page: currentPage,
					page_size: pageSize,
					...(algumFiltro
						? {
								...(titulo && { search: titulo }),
								...(ano && { ano }),
								...(categoria?.length && {
									categorias: categoria,
								}),
								...(tema?.length && {
									temas: tema,
								}),
						  }
						: {}),
				};

				const lista = await requestBibliotecaDocumentos(id, params);

				setDocumentos(
					Array.isArray(lista.results) ? lista.results : []
				);
				setTotalCount(lista.count || 0);
				setTotalPages(Math.ceil((lista.count || 0) / pageSize));
			} catch (error) {
				console.error('❌ Erro ao carregar documentos:', error);
				setDocumentos([]);
				setTotalCount(0);
				setTotalPages(0);
			} finally {
				setLoading(false);
			}
		}

		loadDocs();
	}, [
		currentPage,
		pageSize,
		titulo,
		ano,
		categoria,
		tema,
		categoriasOpcoes,
		temasOpcoes,
	]);

	// Buscar categorias e temas das rotas específicas
	useEffect(() => {
		const token = getUserToken();
		const id = 3;
		// Removido: setTemasOpcoes
		bibliotecaRepositoriosTemas(id, token).then((data) => {
			setTemasOpcoes(Array.isArray(data) ? data : []);
		});
		bibliotecaRepositoriosCategorias(id, token).then((data) => {
			setCategoriasOpcoes(Array.isArray(data) ? data : []);
		});
	}, []);

	// Funções de paginação
	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	const handlePageSizeChange = (newPageSize) => {
		setPageSize(newPageSize);
		setCurrentPage(1); // Reset para primeira página
	};

	// Filtragem dos documentos - agora aplicada apenas aos dados da página atual
	const documentosFiltrados = documentos.filter(
		(doc) =>
			(titulo === '' ||
				doc.titulo?.toLowerCase().includes(titulo.toLowerCase())) &&
			(ano === '' || String(doc.ano) === ano) &&
			(categoria === ''
				? true
				: Array.isArray(doc.categorias)
				? doc.categorias.includes(categoria)
				: doc.categorias === categoria) &&
			(tema === ''
				? true
				: Array.isArray(doc.temas)
				? doc.temas.some((t) => t === tema)
				: doc.temas === tema)
	);

	const anosUnicos = [
		...new Set(documentos.map((doc) => doc.ano).filter(Boolean)),
	];

	return (
		<div className='flex flex-col mx-auto min-h-screen mb-20'>
			<NavBar />

			<div className='font-inter flex flex-col flex-grow'>
				<div className='sm:top-[80px] mt-[80px] pb-4 bg-[#f0f4f8] w-full'>
					<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px]'>
						<div className='px-[2px] py-[18px]'>
							<p className='mx-auto md:mx-10 text-[#004A80] font-bold text-center text-2xl sm:text-3xl md:text-4xl mt-14 mb-12 font-roboto'>
								Maternidades e Hospitais Pediátricos
							</p>
							{/* Filtros */}
							<div className='mb-8'>
								{/* Linha 1: Título do Documento e Ano */}
								<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 mb-6 w-full'>
									<div className='flex flex-col sm:flex-row sm:items-center flex-1'>
										<label
											className='text-[#004A80] font-semibold mb-1 sm:mb-0 sm:mr-2 min-w-[160px] whitespace-nowrap'
											htmlFor='titulo'>
											Título do Documento
										</label>
										<input
											id='titulo'
											type='text'
											placeholder='Título do Documento'
											value={titulo}
											onChange={(e) =>
												setTitulo(e.target.value)
											}
											className='bg-[#F7F9FB] border border-[#E3E3E3] rounded-[8px] px-3 py-1.5 text-[#004A80] outline-none w-full'
										/>
									</div>
									<div className='flex flex-col sm:flex-row sm:items-center w-full sm:w-[200px]'>
										<label
											className='text-[#004A80] font-semibold mb-1 sm:mb-0 sm:mr-2 min-w-[36px]'
											htmlFor='ano'>
											Ano
										</label>
										<select
											id='ano'
											className='bg-[#F7F9FB] border border-[#E3E3E3] rounded-[8px] px-3 py-2 text-[#004A80] outline-none w-full'
											value={ano}
											onChange={(e) =>
												setAno(e.target.value)
											}>
											<option value=''>Todos</option>
											{anosUnicos.map((a) => (
												<option
													key={a}
													value={a}>
													{a}
												</option>
											))}
										</select>
									</div>
								</div>

								{/* Linha 2: Categoria e Tema */}
								<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 w-full'>
									<div className='flex flex-col sm:flex-row sm:items-center w-full'>
										<label
											className='text-[#004A80] font-semibold mb-1 sm:mb-0 sm:mr-2 min-w-[80px]'
											htmlFor='categoria'>
											Categoria
										</label>
										<select
											id='categoria'
											className='bg-[#F7F9FB] border border-[#E3E3E3] rounded-[8px] px-3 py-2 text-[#004A80] outline-none w-full'
											value={categoria}
											onChange={(e) =>
												setCategoria(e.target.value)
											}>
											<option value=''>Todas</option>
											{categoriasOpcoes.map(
												(cat, idx) => (
													<option
														key={cat.nome || cat.id}
														value={cat.id}>
														{cat.nome}
													</option>
												)
											)}
										</select>
									</div>
									<div className='flex flex-col sm:flex-row sm:items-center w-full'>
										<label
											className='text-[#004A80] font-semibold mb-1 sm:mb-0 sm:mr-2 min-w-[56px]'
											htmlFor='tema'>
											Tema
										</label>

										<select
											id='tema'
											className='bg-[#F7F9FB] border border-[#E3E3E3] rounded-[8px] px-3 py-2 text-[#004A80] outline-none w-full'
											value={tema}
											onChange={(e) =>
												setTema(e.target.value)
											}>
											<option value=''>Todos</option>

											{
												// Extrai temas de todos os documentos filtrados
												temasOpcoes.map((t, idx) => (
													<option
														key={t.nome || t.id}
														value={t.id}>
														{t.nome}
													</option>
												))
											}
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='mx-auto w-[90%] sm:w-[95%] items-center max-w-[1136px]'>
					<div className='h-[1px] mt-[28px] mb-8 bg-[#E3E3E3]'></div>
					{documentosFiltrados.length > 0 || documentos.length > 0 ? (
						<div>
							{documentos.map((documento, idx) => (
								<div
									key={documento.id || idx}
									className='my-[28px]'>
									<div className='flex items-start gap-3'>
										<a
											href={documento.arquivo_preview}
											target='_blank'
											rel='noopener noreferrer'>
											<img
												src={IconeDocumento}
												alt='Documento'
												className='w-[26px] h-[28px] mt-6 opacity-70 cursor-pointer object-contain shrink-0 max-w-none'
											/>
										</a>

										<div>
											<div className='text-[#00C0F3] text-[14px]'>
												{Array.isArray(documento.temas)
													? documento.temas.join(', ')
													: documento.temas ||
													  'tema indefinido'}
											</div>
											<a
												href={documento.arquivo_preview}
												target='_blank'
												rel='noopener noreferrer'
												className='text-[#004A80] font-medium hover:text-[#3c7faf] transition-all ease-in-out text-[20px]'>
												{documento.titulo}
											</a>
											<div className='text-[#757575] font-light text-[14px]'>
												{documento.ano || '-'} •{' '}
												{Array.isArray(
													documento.categorias
												)
													? documento.categorias.join(
															', '
													  )
													: documento.categorias ||
													  '-'}
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					) : (
						<div>
							<p className='w-full text-center mt-12 text-[#757575] font-bold text-sm sm:text-lg'>
								NENHUM DOCUMENTO ENCONTRADO
							</p>
							<p className='w-full text-center mt-2 mb-10 sm:mb-0 text-[#757575] text-xs md:text-sm '>
								modifique ou remova os filtros!
							</p>
						</div>
					)}

					{/* Controles de Paginação */}
					{!loading && totalPages > 0 && (
						<div className='flex flex-col sm:flex-row justify-between items-center mt-8 mb-4 gap-4'>
							{/* Informações da página */}
							<div className='text-sm text-[#757575]'>
								Mostrando{' '}
								{documentos.length !==
								documentosFiltrados.length
									? documentosFiltrados.length === 0
										? totalCount
										: documentosFiltrados.length
									: documentos.length}{' '}
								de {totalCount} documentos
							</div>

							{/* Controles de navegação */}
							<div className='flex items-center gap-2'>
								{/* Botão página anterior */}
								<button
									onClick={() =>
										handlePageChange(currentPage - 1)
									}
									disabled={currentPage === 1}
									className={`px-3 py-1 rounded-md text-sm font-medium ${
										currentPage === 1
											? 'bg-gray-100 text-gray-400 cursor-not-allowed'
											: 'bg-[#004A80] text-white hover:bg-[#00508A]'
									}`}>
									Anterior
								</button>

								{/* Números das páginas */}
								<div className='flex items-center gap-1'>
									{Array.from(
										{ length: Math.min(5, totalPages) },
										(_, i) => {
											let pageNum;
											if (totalPages <= 5) {
												pageNum = i + 1;
											} else if (currentPage <= 3) {
												pageNum = i + 1;
											} else if (
												currentPage >=
												totalPages - 2
											) {
												pageNum = totalPages - 4 + i;
											} else {
												pageNum = currentPage - 2 + i;
											}

											return (
												<button
													key={pageNum}
													onClick={() =>
														handlePageChange(
															pageNum
														)
													}
													className={`px-3 py-1 rounded-md text-sm font-medium ${
														currentPage === pageNum
															? 'bg-[#004A80] text-white'
															: 'bg-gray-100 text-gray-700 hover:bg-gray-200'
													}`}>
													{pageNum}
												</button>
											);
										}
									)}
								</div>

								{/* Botão próxima página */}
								<button
									onClick={() =>
										handlePageChange(currentPage + 1)
									}
									disabled={currentPage === totalPages}
									className={`px-3 py-1 rounded-md text-sm font-medium ${
										currentPage === totalPages
											? 'bg-gray-100 text-gray-400 cursor-not-allowed'
											: 'bg-[#004A80] text-white hover:bg-[#00508A]'
									}`}>
									Próxima
								</button>
							</div>

							{/* Seletor de itens por página */}
							<div className='flex items-center gap-2'>
								<label
									htmlFor='pageSize'
									className='text-sm text-[#757575]'>
									Itens por página:
								</label>
								<select
									id='pageSize'
									value={pageSize}
									onChange={(e) =>
										handlePageSizeChange(
											Number(e.target.value)
										)
									}
									className='border border-[#E3E3E3] rounded-md px-2 py-1 text-sm bg-white'>
									<option value={5}>5</option>
									<option value={10}>10</option>
									<option value={20}>20</option>
									<option value={50}>50</option>
								</select>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
